export class ErrorLog {
    message:string;
}
